import { individualSchema } from "../../../Modules/Common/Individual/IndividualValidation";

export const peopleRoot = `People`;
export const SearchPeople = `${peopleRoot}/Search`;
export const getPeopleLookup = `${peopleRoot}/Lookup`;
export const getPeople = `${peopleRoot}/`;
export const GetByIdNumberOrEmployeeCode  = `${peopleRoot}/GetByIdNumberOrEmployeeCode `;
export const GetScorecardLinks = `${peopleRoot}/ScorecardLinks`;
export const RemoveUnusedPeople = `${peopleRoot}/RemoveUnusedPeople`;
export const GetUnusedPeople = `${peopleRoot}/GetUnusedPeople`;
export const getPersonEmployment = `Position/GetByPerson/`;
export const getEmployment = `Position/`;
export const createUpdateEmployment = `Position/`;
export const getLatestPositionForPerson = `${getEmployment}GetLatestForPerson/`;


export const peopleSalaryRoot = `Salary`;
export const getSalariesByPersonId = (personId: number) =>{
    return `${peopleSalaryRoot}/person/${personId}`;
} 

export const getSalariesByPersonIdForYears = (personId: number) =>{
    return `${peopleSalaryRoot}/person/${personId}/years`;
}

export const deleteSalariesByPersonIdForYear = (personId: number, year: number) =>{
    return `${peopleSalaryRoot}/person/${personId}/years/${year}`;
}

export const addSalariesByPersonIdForYear = (personId: number, year: number) =>{
    return `${peopleSalaryRoot}/person/${personId}/year/${year}`;
}

export const saveSalariesByPersonIdForYear = (personId: number) =>{
    return `${peopleSalaryRoot}/person/${personId}`;
}

export const UpdateSalariesByIndividualIdForYears = (individualId: number) =>{
    return `${peopleSalaryRoot}/IndividualSalariesIdForYear/${individualId}`;
}

export const GetIndividualSalariesById = (individualId: number) =>{
    return `${peopleSalaryRoot}/GetIndividualSalaries/${individualId}`;
}

export const AddIndividualSalariesById = (individualId: number, year: number, month : number) =>{
    return `${peopleSalaryRoot}/individual/${individualId}/year/${year}/month/${month}`;
}

export const UpdateIndividualSalaries = (individualId: number) =>{
    return `${peopleSalaryRoot}/IndividualSalaries/${individualId}`;
}
